jQuery(document).ready(function($) {
	$('.js-typewriter').each(function() {
		let strings = $(this).data('typewritewords').split(',');

		new Typewriter($(this)[0], {
		  strings: strings,
		  autoStart: true,
		  cursor: '',
		  loop: true
		});
	});
});